module.exports = __webpack_public_path__ + "../resources/img/ic_rain_weather.ed85c71a.svg";